import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
export class WizardStepModel extends CoreModel {
/**
 * Step label
 */
label?: string;
/**
 * Property for step valid state
 */
isValid?: boolean;
/**
 * It is the constructor for the WizardStepModel component. It takes the values to create the WizardStepModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function WizardStepModel_tsickle_Closure_declarations() {
/**
 * Step label
 * @type {?}
 */
WizardStepModel.prototype.label;
/**
 * Property for step valid state
 * @type {?}
 */
WizardStepModel.prototype.isValid;
}

